<div class="leq-summary-no">
  <ng-container>
    <h4 class="header">Opplysningene du har gitt</h4>
    <p class="sub-header">Klikk på fortsett dersom ingenting har endret seg.</p>
  </ng-container>

  <ng-container *ngIf="kalpAnswers.monthlyNetIncome !== null">
    <hr class="details-divider" />
    <div class="details-container">
      <div class="details-key">Årsinntekt</div>
      <div class="details-value">
        {{ kalpAnswers.monthlyNetIncome | currency: 'kr ':'code':'1.0-0':'sv' }}
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="kalpAnswers.numberOfAdults !== null">
    <hr class="details-divider" />
    <div class="details-container">
      <div class="details-key">Eneste voksne i husholdningen</div>
      <div class="details-value">
        {{ kalpAnswers.numberOfAdults > 0 ? 'Ja' : 'Nei' }}
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="kalpAnswers.numberOfChildren !== null">
    <hr class="details-divider" />
    <div class="details-container">
      <div class="details-key">Antall barn i husholdningen</div>
      <div class="details-value">{{ getNumberOfChildren() }}</div>
    </div>
  </ng-container>

  <ng-container *ngIf="kalpAnswers.typeOfLiving !== null">
    <hr class="details-divider" />
    <div class="details-container">
      <div class="details-key">Boligtype</div>
      <div class="details-value">
        {{ mapTypeOfLivingToReadable(kalpAnswers.typeOfLiving) }}
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="kalpAnswers.monthlyMortgageCost !== null">
    <hr class="details-divider" />
    <div class="details-container">
      <div class="details-key">Boligkostnad per måned</div>
      <div class="details-value">
        {{
          kalpAnswers.monthlyMortgageCost | currency: 'kr ':'code':'1.0-0':'sv'
        }}
        / mnd
      </div>
    </div>
  </ng-container>

  <hr class="details-divider" />
</div>
